import { render, staticRenderFns } from "./LsSelectDictPage.vue?vue&type=template&id=dbc65cec&scoped=true"
import script from "./LsSelectDictPage.vue?vue&type=script&lang=js"
export * from "./LsSelectDictPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc65cec",
  null
  
)

export default component.exports